import React from 'react'
import { Heading } from 'components/Heading'
import { Link } from 'components/Link'
import { Container, Row, Col } from 'components/Layout'
import { CallToAction, TrackedCTA } from 'components/CallToAction'
import VintageBox from 'components/VintageBox'
import { prepareData } from 'utils/googleData'
import { FileSearchOutlined as FaMapMarkedAlt } from '@ant-design/icons'
import { heading, section } from '../classes'
import ilpappsVideo from './ilpapps-intro.mp4'
import CloudorsVideo from './thecloudors-intro.mp4'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const BGImg = ({ image, title, className, children }) => {
    return (
        <div className="relative mx-auto w-full">
            <div className={`md:z-2 absolute z-10 flex justify-center md:relative ${className}`}>{children}</div>
            <div className="md:hidden">
                <GatsbyImage
                    loading="eager"
                    placeholder="none"
                    image={image}
                    title={title}
                    className="left-0 z-0 max-h-[32rem] w-full rounded-[10px] opacity-30"
                />
            </div>
        </div>
    )
}

export function Hero4(props) {
    const {
        enable,
        title,
        subtitle,
        video,
        description,
        cta,
        direction,
        style,
        gatsbyImage,
        url,
        features,
        gatsbyTransformed,
        backgroundColor = '#00B9C8',
        textColor = 'text-white',
        darkBackgroundColor = '#00244d',
    } = prepareData({ props })

    if (enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }

    const { heroImage } = useStaticQuery(
        graphql`
            query {
                heroImage: file(relativePath: { eq: "poster.png" }) {
                    childImageSharp {
                        gatsbyImageData(width: 2000, quality: 50, webpOptions: { quality: 70 }, breakpoints: [760])
                    }
                }
            }
        `
    )

    // Dynamically select the video source based on the video prop
    let selectedVideo
    switch (video) {
        case 'ilpapps-intro.mp4':
            selectedVideo = ilpappsVideo
            break
        case 'thecloudors-intro.mp4':
            selectedVideo = CloudorsVideo
            break
        default: // Default video if none matches
            selectedVideo = ilpappsVideo
            break
    }

    return (
        <section id="hero4" className={`relative ${section('mt-4 mb-10 md:mt-8 md:mb-4')} `}>
            <div className={` ${backgroundColor} dark:${darkBackgroundColor} ${style}`}>
                <BGImg title="heroImage" image={gatsbyTransformed}>
                    <div className="relative z-10 flex flex-wrap items-center md:flex-nowrap">
                        <Col sm={12} md={6} className="z-20 flex flex-col justify-center text-center md:text-left">
                            <Container fullWidthSM>
                                <h1
                                    className="mb-2 text-3xl leading-none md:text-4xl"
                                    dangerouslySetInnerHTML={{ __html: title }}
                                ></h1>
                                <h3 className={`font-semibold opacity-60 `}>
                                    <p className="mb-2 pb-0 text-xl md:mb-0">{subtitle}</p>
                                </h3>
                                <div className="mt-6 flex justify-center md:justify-start">
                                    <VintageBox right={true} vintageOne={true}>
                                        <TrackedCTA
                                            type="primary"
                                            size="lg"
                                            to={cta?.url}
                                            event={{ name: cta?.event || `clicked Get a demo` }}
                                        >
                                            <FaMapMarkedAlt size={21} className="icon-left" />
                                            {cta?.label}
                                        </TrackedCTA>
                                    </VintageBox>
                                </div>
                            </Container>
                        </Col>
                        {typeof window !== 'undefined' && (
                            <Col sm={12} md={6} className="z-10 mt-4 flex justify-center md:mt-0 md:justify-end">
                                <Link to={url}>
                                    <video
                                        autoPlay
                                        muted
                                        loop
                                        preload="metadata"
                                        className="hidden max-h-[400px] w-full md:block md:max-h-[none] md:w-auto"
                                    >
                                        <source src={selectedVideo} type="video/mp4"></source>
                                    </video>
                                </Link>
                            </Col>
                        )}
                    </div>
                </BGImg>
                <div className="absolute top-0 left-0 z-0 h-full w-full md:hidden">
                    <GatsbyImage
                        loading="eager"
                        placeholder="none"
                        image={gatsbyTransformed}
                        title="heroImage"
                        className="left-0 max-h-[32rem] w-full rounded-[10px] opacity-30"
                    />
                </div>
            </div>
        </section>
    )
}

export default Hero4
